export const POLICY_KEYS = [
  'tester_agreement',
  'privacy_policy',
  'payment_reimbursement_policy',
  'tax_contractor_declaration',
  'nda',
];

export const POLICY_VERSIONS = {
  tester_agreement: 'tester-agreement-v1',
  privacy_policy: 'privacy-policy-v1',
  payment_reimbursement_policy: 'payment-reimbursement-v1',
  tax_contractor_declaration: 'tax-contractor-v1',
  nda: 'tester-agreement-nda-v1',
};

export const POLICY_LABELS = {
  tester_agreement: 'Tester Agreement',
  privacy_policy: 'Privacy Policy',
  payment_reimbursement_policy: 'Payment & Reimbursement Policy',
  tax_contractor_declaration: 'Tax / Contractor Declaration',
  nda: 'NDA / Confidentiality Terms',
};

/**
 * Public URLs for the policies that have a published page. Signup presents a
 * single combined acceptance, so the tester needs a way to actually read each
 * document before ticking it. Only the two that exist are linked — pointing at
 * a missing page would be worse than plain text.
 */
export const POLICY_DOC_PATHS = {
  tester_agreement: '/legal/tester-terms',
  privacy_policy: '/legal/tester-privacy',
};

export const emptyLegalAcceptances = () =>
  POLICY_KEYS.reduce((acc, key) => {
    acc[key] = false;
    return acc;
  }, {});
